import React from "react";

interface ProductGstTabProps {
  data: any;
  onChange: (field: string, value: any) => void;
  isEdit: boolean;
  onUpdate?: () => void;
  isLoading?: boolean;
}

const formStyles = {
  lableStyle: "block text-sm text-[#3F5260] font-medium mb-1",
  inputStyle:
    "w-full px-3 py-2 border border-[#D0D5DE] outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 text-sm",
};

export const ProductGstTab: React.FC<ProductGstTabProps> = ({
  data,
  onChange,
  isEdit,
  onUpdate,
  isLoading,
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className={formStyles.lableStyle}>HSN Number</label>
          <input
            type="text"
            value={data.hsnNumber}
            onChange={(e) => onChange("hsnNumber", e.target.value)}
            className={formStyles.inputStyle}
            placeholder="Enter HSN Number"
          />
        </div>
        <div className="flex gap-4">
          <div className="flex-1">
            <label className={formStyles.lableStyle}>CGST (%)</label>
            <input
              type="number"
              step="0.01"
              value={data.cgst}
              onChange={(e) => onChange("cgst", Number(e.target.value))}
              className={formStyles.inputStyle}
              placeholder="e.g. 6"
            />
          </div>
          <div className="flex-1">
            <label className={formStyles.lableStyle}>SGST (%)</label>
            <input
              type="number"
              step="0.01"
              value={data.sgst}
              onChange={(e) => onChange("sgst", Number(e.target.value))}
              className={formStyles.inputStyle}
              placeholder="e.g. 6"
            />
          </div>
        </div>
      </div>

      {isEdit && (
        <div className="flex justify-end mt-6">
          <button
            type="button"
            onClick={onUpdate}
            disabled={isLoading}
            className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition"
          >
            {isLoading ? "Updating..." : "Update Taxes"}
          </button>
        </div>
      )}
    </div>
  );
};
